import { isStandaloneApp } from 'app/utils/browser';
import LINKS from 'app/const/links';


const {
    DELIVERY_PAGE,
    EVERYDAY_SET,
    SWEET_PAGE,
    VEG_PAGE,
    LITE_PAGE,
    NZ_PAGE,
    PREMIUM_SET,
    QUALITY_PAGE,
    SPA_MENU,
    SPA_SUBSCRIPTION_INFO,
    TRIAL_FIRST_ORDER_SET,
    FAST_PAGE,
    SOUP_PAGE,
    BREAKFAST_PAGE,

    KIDS_PAGE,
    GREEN_PAGE,
    GUESTS_PAGE,
    HITS_PAGE,
    CREATIVITY_PAGE,
    SPEED_PAGE,
    // CHRISTMAS_PAGE,
    PREMIUM_SET_GREEN_VERSION,
} = LINKS;

const isStandalone = isStandaloneApp();


const newTabLinkAttrs = {
    target: '_blank',
    rel: 'noopener noreferrer',
};

const currentTabLinkAttrs = {
    target: '_self',
};

export const getTopLevelLinks = (options) => {
    const {
        onClickNavLink,
    } = options;

    return [
        // {
        //     id: CHRISTMAS_PAGE.id,
        //     data: {
        //         titleTrKey: 'Старый новый год',
        //         href: CHRISTMAS_PAGE.hrefRu,
        //         type: 'link',
        //         badge: 'tree',
        //         linkAttrs: isStandalone ? currentTabLinkAttrs : newTabLinkAttrs,
        //         handler: onClickNavLink,
        //     },
        // },
        {
            id: TRIAL_FIRST_ORDER_SET.id,
            data: {
                titleTrKey: 'mobileNav.trial',
                href: TRIAL_FIRST_ORDER_SET.hrefBasket,
                type: 'link',
                badge: 'percent',
                linkAttrs: isStandalone ? currentTabLinkAttrs : newTabLinkAttrs,
                handler: onClickNavLink,
            },
        },
        {
            id: EVERYDAY_SET.id,
            data: {
                titleTrKey: 'mobileNav.tomorrow',
                href: EVERYDAY_SET.href,
                type: 'link',
                handler: onClickNavLink,
            },
        },
        {
            id: SPA_MENU.id,
            data: {
                titleTrKey: 'mobileNav.menuDishes',
                href: SPA_MENU.href,
                handler: onClickNavLink,
                type: 'navLink',
            },
        },
    ];
};


// Графа "Для особых случаев" в бургер меню
export const forSpecialOccasionsLinks = (options) => {
    const {
        locale,
        onClickNavLink,
    } = options;

    const isEnLocale = locale === 'en';

    return [
        {
            id: 'NY_PAGE',
            data: {
                title: 'На Новый Год',
                href: '/blyuda-dlya-novogodnego-stola/',
                handler: onClickNavLink,
                type: 'link',
                trackId: 'ny',
                badge: 'tree',
            },
        },
        {
            id: 'hp',
            data: {
                title: isEnLocale ? 'hp' : 'Еда и сладости из Хогвартса',
                href: '/hp/',
                type: 'link',
                handler: onClickNavLink,
                trackId: 'hp',
            },
        },
        // {
        //     id: 'halloween',
        //     data: {
        //         title: isEnLocale ? 'halloween' : 'На Хэллоуин',
        //         href: '/halloween/',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'halloween',
        //     },
        // },
        {
            id: KIDS_PAGE.id,
            data: {
                title: isEnLocale ? 'Kids' : 'Детское',
                href: isEnLocale ? KIDS_PAGE.hrefEn : KIDS_PAGE.hrefRu,
                type: 'link',
                handler: onClickNavLink,
                trackId: KIDS_PAGE.trackId,
            },
        },
        {
            id: GREEN_PAGE.id,
            data: {
                title: 'Green',
                href: GREEN_PAGE.href,
                type: 'link',
                handler: onClickNavLink,
                // TODO:
                trackId: null,
            },
        },
        {
            id: GUESTS_PAGE.id,
            data: {
                title: isEnLocale ? 'When guests arrive' : 'К приходу гостей',
                href: GUESTS_PAGE.href,
                type: 'link',
                handler: onClickNavLink,
                // TODO:
                trackId: null,
            },
        },
        {
            id: HITS_PAGE.id,
            data: {
                title: isEnLocale ? 'Hits' : 'Хиты',
                href: HITS_PAGE.href,
                type: 'link',
                handler: onClickNavLink,
                // TODO:
                trackId: null,
            },
        },
        {
            id: CREATIVITY_PAGE.id,
            data: {
                title: isEnLocale ? 'Time for creativity' : 'Время для творчества',
                href: CREATIVITY_PAGE.href,
                type: 'link',
                handler: onClickNavLink,
                // TODO:
                trackId: null,
            },
        },
        {
            id: 'SOUP_PAGE',
            data: {
                title: isEnLocale ? 'Soups' : 'Супы',
                href: '/produkty-dlya-supa/',
                type: 'link',
                handler: onClickNavLink,
                trackId: SOUP_PAGE.trackId,
            },
        },
        {
            id: VEG_PAGE.id,
            data: {
                titleTrKey: 'mobileNav.vegan',
                title: '   Вег-меню',
                href: isEnLocale ? VEG_PAGE.hrefEn : VEG_PAGE.hrefRu,
                type: 'link',
                handler: onClickNavLink,
                trackId: VEG_PAGE.trackId,
            },
        },
        {
            id: SPEED_PAGE.id,
            data: {
                title: isEnLocale ? 'Ready in 15 minutes' : 'Готовим за 15 минут',
                href: SPEED_PAGE.hrefRu,
                type: 'link',
                handler: onClickNavLink,
                trackId: FAST_PAGE.trackId,
            },
        },
        {
            id: SWEET_PAGE.id,
            data: {
                titleTrKey: 'mobileNav.sweat',
                title: isEnLocale ? 'Let`s bake together' : 'Печём вместе',
                href: isEnLocale ? SWEET_PAGE.hrefEn : SWEET_PAGE.hrefRu,
                type: 'link',
                handler: onClickNavLink,
                trackId: SWEET_PAGE.trackId,
            },
        },
        {
            id: 'BREAKFAST_PAGE',
            data: {
                titleTrKey: 'mobileNav.breakfast',
                title: isEnLocale ? 'Bohemian Breakfasts' : 'Богемные завтраки',
                href: '/produkty-dlya-zavtraka/',
                type: 'link',
                handler: onClickNavLink,
                trackId: BREAKFAST_PAGE.trackId,
            },
        },
        {
            id: NZ_PAGE.id,
            data: {
                titleTrKey: 'mobileNav.nz',
                title: isEnLocale ? 'In store' : 'Про запас',
                href: isEnLocale ? NZ_PAGE.hrefEn : NZ_PAGE.hrefRu,
                type: 'link',
                handler: onClickNavLink,
                trackId: NZ_PAGE.trackId,
            },
        },
        // {
        //     id: 'school',
        //     data: {
        //         title: isEnLocale ? 'school' : 'Подарок учителю',
        //         href: '/backtoschool/',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'school',
        //     },
        // },
        // {
        //     id: 'gryadka',
        //     data: {
        //         title: isEnLocale ? 'gryadka' : 'С грядки из деревни',
        //         href: '/menu?st=gryadka',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'gryadka',
        //     },
        // },
        // {
        //     id: '/dacha',
        //     data: {
        //         title: isEnLocale ? 'dacha' : 'Едем на шашлыки',
        //         href: '/dacha',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'dacha',
        //     },
        // },
        // {
        //     id: 'odyssey',
        //     data: {
        //         title: isEnLocale ? 'dacha' : 'К фильму «Одиссея»',
        //         href: '/theodyssey',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'odyssey',
        //     },
        // },
        // {
        //     id: '/biomio',
        //     data: {
        //         title: isEnLocale ? 'Biomio' : 'Ваши полезные привычки',
        //         href: '/biomio',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'biomio',
        //     },
        // },
        // {
        //     id: '/march',
        //     data: {
        //         title: isEnLocale ? 'march' : 'Для великих женщин',
        //         href: '/march',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'march',
        //     },
        // },
        // {
        //     id: '/marchgifts',
        //     data: {
        //         title: isEnLocale ? 'March gifts' : 'Подарки к 8 марта',
        //         href: '/marchgifts',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'marchgifts',
        //     },
        // },
        // {
        //     id: 'NY_PAGE',
        //     data: {
        //         title: 'На Рождество',
        //         href: '/blyuda-dlya-novogodnego-stola/',
        //         handler: onClickNavLink,
        //         type: 'link',
        //         trackId: 'ny',
        //         badge: 'tree',
        //     },
        // },
        // {
        //     id: '/romantic',
        //     data: {
        //         title: isEnLocale ? 'Romantic' : 'Свидание дома',
        //         href: '/romantic',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'romantic',
        //     },
        // },
        // },
        //         {
        //     id: '/easter',
        //     data: {
        //         title: isEnLocale ? 'easter' : 'Празднуем Пасху',
        //         href: '/easterbox',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'easter',
        //     },
        // },

        // {
        //     id: '/maslenitsa',
        //     data: {
        //         title: isEnLocale ? 'Maslenitsa' : 'Масленица с подарками',
        //         href: '/maslenitsa/',
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: 'maslenitsa',
        //     },
        // },
        // {
        //     id: 'PREMIUM_SET',
        //     data: {
        //         titleTrKey: 'mobileNav.premium',
        //         href: PREMIUM_SET.href,
        //         type: 'link',
        //         handler: onClickNavLink,
        //         trackId: PREMIUM_SET.trackId,
        //     },
        // },
        //     {
        //         id: FAST_PAGE.id,
        //         data: {
        //             titleTrKey: 'mobileNav.vegan',
        //             href: FAST_PAGE.hrefRu,
        //             type: 'link',
        //             handler: onClickNavLink,
        //             trackId: FAST_PAGE.trackId,
        //         },
        //     },
    ];
};

// Грвфф "О сервисе" в бургер меню
export const getAboutServiceLinks = (options) => {
    const {
        locale,
        onClickNavLink,
    } = options;

    const isEnLocale = locale === 'en';

    return [
        {
            id: QUALITY_PAGE.id,
            data: {
                titleTrKey: 'mobileNav.quality',
                href: isEnLocale ? QUALITY_PAGE.hrefEn : QUALITY_PAGE.hrefRu,
                type: 'link',
                handler: onClickNavLink,
            },
        },
        {
            id: DELIVERY_PAGE.id,
            data: {
                titleTrKey: 'mobileNav.delivery',
                href: DELIVERY_PAGE.hrefRu,
                type: 'link',
                handler: onClickNavLink,
            },
        },
        {
            id: 'Версия на другом языке',
            data: {
                titleTrKey: 'mobileNav.foreignLang',
                href: locale === 'ru' ? 'English version' : 'Русская версия',
                handler: onClickNavLink,
                type: 'link',
            },
        },
    ];
};


export const getFiveSetLinks = (options) => {
    const {
        locale,
        onClickNavLink,
    } = options;

    return [
        {
            id: 10,
            data: {
                titleTrKey: 'mobileNav.profitable',
                href: '/basket',
                type: 'link',
                handler: onClickNavLink,
            },
        },
        {
            id: 100,
            data: {
                titleTrKey: 'mobileNav.topFive',
                href: '/basket',
                type: 'link',
                handler: onClickNavLink,
            },
        },
        {
            id: 101,
            data: {
                titleTrKey: 'mobileNav.green',
                href: '/basket',
                handler: onClickNavLink,
                type: 'link',
            },
        },
    ];
};
